import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import "./LimitUsageBanner.style";

class LimitUsageBanner extends PolymerElement {
  static get template() {
    return html`
      <style include="limit-usage-banner-style"></style>
      <div class="limit-usage-banner" role="status">
        <div class="limit-usage-banner__text" inner-h-t-m-l="[[limitLabelHtml]]"></div>
        <button
          type="button"
          class="limit-usage-banner__cta-btn"
          aria-label="Tambah Limit"
          on-click="_onClickTambahLimit"
        >
          Tambah Limit
        </button>
      </div>
    `;
  }

  static get properties() {
    return {
      chatCredit: { type: Object, value: null },
      limitLabelHtml: {
        type: String,
        computed: "_computeLimitLabelHtml(chatCredit)",
      },
    };
  }

  // Replace #monthly_credits in limit_label with the preview count from chat_credit.
  _computeLimitLabelHtml(chatCredit) {
    const credit = chatCredit && typeof chatCredit === "object" ? chatCredit : null;
    const template =
      credit && credit.limit_label != null ? String(credit.limit_label) : "";
    if (!template) return "";
    const previewCount = credit.total != null ? String(credit.total) : "0";
    return template.replace(/#monthly_credits/g, previewCount);
  }

  // Tell the AI page to open the unlimited-access popup.
  _onClickTambahLimit() {
    this.dispatchEvent(
      new CustomEvent("limit-usage-cta-click", {
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define("limit-usage-banner", LimitUsageBanner);
